import React, { useEffect, useState } from 'react';
import { AgentAccessPanel } from '../pages/marketing/AgentAccessPanel';
import '../pages/marketing/AgentAccessPanel.scss';

interface AgentAccessModalProps {
  onClose: () => void;
}

/**
 * Fullscreen header host for the Agent Access console. It opens fully expanded —
 * the panel is the entire point of the modal, so there's no collapse. Dark,
 * terminal-styled by default; under the Graphite/Blossom theme it is re-skinned
 * to the warm-fog palette via themes/graphite/agent-access.scss (scoped to
 * html[data-app-theme='graphite']). Esc or the ✕ closes it; the panel self-gates
 * on owner authority (renders nothing for non-owners) and the opening header
 * icon is owner-gated too.
 */
const AgentAccessModal: React.FC<AgentAccessModalProps> = ({ onClose }) => {
  const [show, setShow] = useState(true);
  const close = () => { setShow(false); onClose(); };

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    // Lock background scroll while the fullscreen console is open.
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show) return null;

  return (
    <div className="aam__overlay" role="dialog" aria-modal="true" aria-label="Agent Access">
      <div className="aam__bar">
        <span className="aam__title">agent access</span>
        <span className="aam__subtitle">external agents · owner-approved, time-boxed, single-client</span>
        <button type="button" className="aam__close" onClick={close} aria-label="Close">esc&nbsp;✕</button>
      </div>
      <div className="aam__body">
        <div className="aam__inner">
          <AgentAccessPanel />
        </div>
      </div>
    </div>
  );
};

export default AgentAccessModal;
